import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, MessageSquareText, Lightbulb, Rocket } from 'lucide-react';
export function AliceApp() {
  const steps = [{
    icon: <MessageSquareText size={24} className="text-link-blue" data-id="element-16" />,
    title: 'Describe tu negocio',
    text: 'Cuéntale a Alice qué vendes, a quién ayudas y cuál es tu objetivo.'
  }, {
    icon: <Lightbulb size={24} className="text-link-blue" data-id="element-17" />,
    title: 'Recibe una estrategia',
    text: 'Alice te organiza ideas, campañas, mensajes y próximos pasos.'
  }, {
    icon: <Rocket size={24} className="text-link-blue" data-id="element-18" />,
    title: 'Ejecuta con Link Academy',
    text: 'Aprende a aplicar esa estrategia con cursos, comunidad y mentorías.'
  }];
  return <section id="alice-app" className="py-12 lg:py-16 bg-link-navy relative overflow-hidden" data-id="element-19">
      {/* Tech Background Elements */}
      <div className="absolute inset-0 opacity-10" data-id="element-20">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMSIgY3k9IjEiIHI9IjEiIGZpbGw9IiNGRkZGRkYiLz48L3N2Zz4=')]" data-id="element-21" />
      </div>
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-link-blue/20 to-transparent blur-3xl" data-id="element-22" />
      <div className="absolute bottom-0 left-0 w-1/2 h-full bg-gradient-to-r from-link-blue/20 to-transparent blur-3xl" data-id="element-23" />

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-24">
        <div className="text-center max-w-3xl mx-auto mb-10" data-id="element-25">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 text-white text-sm font-semibold mb-6 backdrop-blur-sm border border-white/20" data-id="element-26">
            <Sparkles size={16} className="text-blue-300" data-id="element-27" />
            Inteligencia Artificial Integrada
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6" data-id="element-28">
            Conoce Alice: tu mentora de marketing con IA
          </h2>
          <p className="text-xl text-blue-100 leading-relaxed" data-id="element-29">
            Le dices qué vendes, a quién le vendes y qué resultado quieres.
            Alice te ayuda a construir una estrategia clara para avanzar.
          </p>
        </div>

        <div className="flex flex-col gap-12 max-w-4xl mx-auto" data-id="element-30">
          {/* Mockup Area */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative" data-id="element-31">
            <div className="absolute -inset-1 bg-gradient-to-r from-link-blue to-cyan-400 rounded-[2.5rem] blur opacity-30 animate-pulse" data-id="element-32" />
            <div className="relative bg-white rounded-2xl shadow-2xl overflow-hidden border-4 border-white/10" data-id="element-33">
              <img src="https://cdn.magicpatterns.com/uploads/nfBAERZEkcCkXqm2dVyeDp/image.png" alt="Alice App" className="w-full h-auto object-cover block" data-id="element-34" />
            </div>
          </motion.div>

          {/* Steps */}
          <div className="grid md:grid-cols-3 gap-6" data-id="element-35">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex flex-col items-center text-center gap-4 bg-white/5 p-6 rounded-2xl border border-white/10 backdrop-blur-sm hover:bg-white/10 transition-colors" data-id="element-36">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-white flex items-center justify-center shadow-[0_0_15px_rgba(0,109,255,0.5)]" data-id="element-37">
                  {step.icon}
                </div>
                <div data-id="element-38">
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-39">
                    {step.title}
                  </h3>
                  <p className="text-blue-100 leading-relaxed" data-id="element-40">{step.text}</p>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="flex justify-center" data-id="element-41">
            <a href="#unete" className="inline-flex justify-center items-center bg-link-blue hover:bg-blue-600 text-white px-8 py-4 rounded-full font-semibold text-lg transition-all shadow-lg shadow-link-blue/50 hover:-translate-y-1" data-id="element-42">
              Quiero probar Link Academy
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}